import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "simple-table mb-0" }

import { PropType } from "vue";
import { useRouter } from "vue-router";

import { useFilesStore } from "@/stores/files.store";
import { useUIFilesStore } from "@/stores/ui-files.store";

import { ContentStructureSection } from "@/models/content-structure.model";
import { LibraryFile } from "@/models/files.model";
import { SectionFile } from "@/models/product-section.model";

import RemoveAttachment from "@/components/popups/attachments/RemoveAttachment.vue";
import RenameAttachment from "@/components/popups/attachments/RenameAttachment.vue";
import UploadFileVersion from "@/components/popups/attachments/UploadFileVersion.vue";
import FilesListItem from "@/components/right-sidebars/content-sidebar/authoring-tool/FilesListItem.vue";

interface UnavailableFile {
  name: string;
  location: string;
  is_external: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilesList',
  props: {
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  },
  filesToDisplay: {
    required: true,
    type: Array as PropType<SectionFile[] | LibraryFile[] | UnavailableFile[]>
  },
  isAttachmentsTable: {
    required: false,
    type: Boolean,
    default: true
  }
},
  emits: ["previewAttachment"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const uiFilesStore = useUIFilesStore();
const filesStore = useFilesStore();

const props = __props;

const openUploadVersionModal = (file: SectionFile | LibraryFile): void => {
  uiFilesStore.openAttachmentVersionModal(file);
};

const launchRemoveAttachmentDialog = (file: SectionFile): void => {
  uiFilesStore.openRemoveAttachmentModal(file);
};

const getFileObject = (fileId: number): LibraryFile | undefined => {
  if (filesStore.files) {
    return filesStore.files.find((f: LibraryFile): boolean => f.id === fileId);
  }
  return undefined;
};
const launchRenamePopup = (file: SectionFile | LibraryFile): void => {
  const fileForRenaming = getFileObject(file.id);
  if (fileForRenaming) {
    uiFilesStore.openRenameAttachmentModal(fileForRenaming);
  }
};

const showFileInLibrary = (file: SectionFile | LibraryFile): void => {
  const validURLFileName = file.name.split(".")[0];
  const query = {
    filters: `name--${validURLFileName}--default`,
    sidebar: `attachment-${file.id}`
  };

  router.push({
    path: "/attachments",
    query: query
  });
};

const emit = __emit;
const previewAttachment = (fileLocation: string): void => {
  emit("previewAttachment", fileLocation);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Name"),
          _createElementVNode("th", null, "Size"),
          _createElementVNode("th", null, "Date Added"),
          _createElementVNode("th"),
          _createElementVNode("th"),
          _createElementVNode("th")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filesToDisplay, (file) => {
          return (_openBlock(), _createBlock(FilesListItem, {
            key: file.id ? file.id : file.location,
            file: file,
            "is-attachment-table": __props.isAttachmentsTable,
            onLaunchRenamePopup: launchRenamePopup,
            onOpenUploadVersionModal: openUploadVersionModal,
            onShowFileInLibrary: showFileInLibrary,
            onLaunchRemoveAttachmentDialog: launchRemoveAttachmentDialog,
            onPreviewAttachment: previewAttachment
          }, null, 8, ["file", "is-attachment-table"]))
        }), 128))
      ])
    ]),
    (_unref(uiFilesStore).isFileVersionModalOpen)
      ? (_openBlock(), _createBlock(UploadFileVersion, {
          key: 0,
          "product-id": __props.section.product_id
        }, null, 8, ["product-id"]))
      : _createCommentVNode("", true),
    (_unref(uiFilesStore).isRemoveAttachmentPopupOpen)
      ? (_openBlock(), _createBlock(RemoveAttachment, {
          key: 1,
          section: __props.section
        }, null, 8, ["section"]))
      : _createCommentVNode("", true),
    (_unref(uiFilesStore).isRenameAttachmentPopupOpen)
      ? (_openBlock(), _createBlock(RenameAttachment, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})